import Form from '@components/data-driven-form/Form.jsx';
import { useQuery } from '@tanstack/react-query';
import { JpaQueries, JPA_QUERY_KEYS } from '@api/services/jpa';
import Loader from '@components/loader/Loader';
import { useJpa, useRequest } from '@stores';
import { QUESTION_TYPE } from '@components/data-driven-form/ddf.validation';

const JpaInfo = ({ formId, group, name, requestId, stepNo, version, componentId }) => {
  const { setAnswer, setContactAnswer } = useJpa();
  const { isFormReadOnly: isReadOnly, updateSection, isSectionValid, getSections } = useRequest();

  const { data, isLoading } = useQuery({
    queryKey: [JPA_QUERY_KEYS.GET_INITIAL_SECTION, formId],
    queryFn: () =>
      JpaQueries.getInitialSection({
        formId,
        requestId,
        version: version || 0,
      }),
    enabled: Number.isInteger(formId),
  });

  const onChange = (val, jpaQuestionID, jpaQuestionTypeID, jpaFormID) => {
    if (jpaQuestionTypeID === QUESTION_TYPE.contact || jpaQuestionTypeID === QUESTION_TYPE.basicContact) {
      setContactAnswer(val, jpaQuestionID, jpaQuestionTypeID, jpaFormID);
    } else {
      // Format react-hook-form values to internal answer object
      setAnswer(val, jpaQuestionID, jpaQuestionTypeID, jpaFormID);
    }
    updateSection(stepNo, { dirty: true });
  };

  const handleOnValidationChange = (isValid) => {
    if (isSectionValid(stepNo) === isValid) {
      return;
    } else {
      updateSection(stepNo, {
        valid: isReadOnly ? true : isValid,
        label: name,
      });
      if (group) {
        const parentIndex = group?.parentIndex;

        if (!parentIndex) {
          return;
        }
        const currentSections = getSections();
        const isGroupValid = group?.indexes.every((index) => currentSections[index]?.valid);

        updateSection(parentIndex, {
          valid: isReadOnly ? true : isGroupValid,
        });
      }
    }
  };

  if (isLoading) {
    return <Loader variant='page' />;
  }

  return (
    <Form
      componentId={componentId}
      formData={data?.jpaForm}
      isInformation={true}
      isReadOnly={isReadOnly}
      onChange={onChange}
      onValidationChange={handleOnValidationChange}
      stepNo={stepNo}
    />
  );
};
export default JpaInfo;
